<template>
  <v-app id="inspire">

    <ContSidebar :isSidebarMini.sync="isSidebarMini"/>
    <!-- <ContHeader @toggle-sidebar-mini="isSidebarMini = !isSidebarMini"/> -->

    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <!-- snackbar -->
    <v-snackbar
      top
      color="yellow lighten-4"
      class="red--text darken-5"
      :timeout="$store.state.vSnackbar.timeout"
      v-model="$store.state.vSnackbar.show"
    >
      {{ this.$store.state.vSnackbar.text }}
      <v-btn
        flat
        color="grey darken-1"
        @click.native="$store.commit('setVSnackbar', ['', false])">
        <v-icon small>close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Dialog Raw Data -->
    <v-dialog
      v-model="$store.state.isDialogRawData"
      width="980">
      <v-card>
        <v-card-title class="headline">
          Raw Data
          <v-spacer/>
          <v-btn
            icon
            @click.native="$store.dispatch('toggleDialogRawData')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <div
            class="text-xs-center mt-3"
            v-if="!$store.state.dialogRawData">
            <v-progress-circular
              indeterminate
              color="primary"/>
          </div>
          <pre>{{ $store.state.dialogRawData }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>

    <CheckUpdate/>

  </v-app>
</template>

<script>
import ContSidebar from './ContSidebar'
import ContHeader from './ContHeader'
import CheckUpdate from './CheckUpdate'

export default {
  components: {
    ContSidebar,
    ContHeader,
    CheckUpdate
  },
  data () {
    return {
      isSidebarMini: false,
      navItems: [
        { icon: 'contacts', name: 'Contacts' },
        { icon: 'history', name: 'Frequently contacted' },
        { icon: 'content_copy', name: 'Duplicates' },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          name: 'Labels',
          model: true,
          children: [
            { icon: 'add', name: 'Create label' }
          ]
        },
        {
          icon: 'keyboard_arrow_up',
          'icon-alt': 'keyboard_arrow_down',
          name: 'More',
          model: false,
          children: [
            { name: 'Import' },
            { name: 'Export' },
            { name: 'Print' },
            { name: 'Undo changes' },
            { name: 'Other contacts' }
          ]
        },
        { icon: 'person', name: '用户', url: '/user' },
        { icon: 'grain', name: '分类法', url: '/taxonomy' },
        { icon: 'settings', name: '设置', url: '/options' },
        { icon: 'widgets', name: '模块', url: '/modulemgr' },
        { icon: 'chat_bubble', name: 'Send feedback' },
        { icon: 'help', name: 'Help' },
        { icon: 'phonelink', name: 'App downloads' },
        { icon: 'keyboard', name: 'Go to the old version' }
      ]
    }
  },
  computed: {
    showParcelDialogView: {
      get () {
        return this.$store.state.layout.showParcelDialogView
      },
      set (v) {
        this.$store.commit('layout/setShowParcelDialogView', v)
      }
    },
    showOrderViewDialog: {
      get () {
        return this.$store.state.layout.showOrderViewDialog
      },
      set (v) {
        this.$store.commit('layout/setShowOrderViewDialog', v)
      }
    },
    showKdTrackingDialogView: {
      get () {
        return this.$store.state.layout.showKdTrackingDialogView
      },
      set (v) {
        this.$store.commit('layout/setShowKdTrackingDialogView', v)
      }
    }
  },
  // 初始化数据
  created () {
    this.$store.dispatch('init')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/_layout/Container.vue